module.exports = __webpack_public_path__ + "media/img/pages/companies/lonza-dd8df77d5b3163821ce6fb4d9a3f4dab.png";